import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { getProductOptions } from "@faire/retailer-visitor-shared/views/product/utils/productUtils";
import { FaireDate } from "@faire/web--source/common/FaireDate";
import { FaireDateRange } from "@faire/web--source/common/FaireDateRange";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";
import { ProductVariationType } from "@faire/web-api--source/indigofair/data/ProductVariationType";
import isEqual from "lodash/isEqual";
export var PerStyleVariationMapBuilder = function PerStyleVariationMapBuilder() {
    "use strict";
    _class_call_check(this, PerStyleVariationMapBuilder);
};
PerStyleVariationMapBuilder.buildVariationMap = function(selectedOptionToken, product) {
    var _product_purchase_information;
    var _product_purchase_information_style_groups;
    var styleGroups = (_product_purchase_information_style_groups = (_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : _product_purchase_information.style_groups) !== null && _product_purchase_information_style_groups !== void 0 ? _product_purchase_information_style_groups : {};
    var styleGroupKeys = Object.keys(styleGroups);
    var styleOptionVariations;
    // We cannot create open sizing products if there are no size
    // variations on brand portal. So if there is per style MOQ,
    // there will be size variation.
    var styleGroupKey = styleGroupKeys.find(function(key) {
        var _styleGroups_key;
        return (_styleGroups_key = styleGroups[key]) === null || _styleGroups_key === void 0 ? void 0 : _styleGroups_key.option_tokens.includes(selectedOptionToken);
    });
    // open sizing products with single variation will have group key of ""
    var styleGroup = styleGroups[styleGroupKey !== null && styleGroupKey !== void 0 ? styleGroupKey : ""];
    if (isNotUndefined(styleGroup)) {
        var _product_purchase_information1;
        styleOptionVariations = PerStyleVariationMapBuilder.getDefaultOptionVariation(styleGroup, product);
        var _styleOptionVariations_reduce;
        var combinedSizeInventory = (_styleOptionVariations_reduce = styleOptionVariations === null || styleOptionVariations === void 0 ? void 0 : styleOptionVariations.reduce(function(accumulator, variation) {
            return accumulator + variation.inventory;
        }, 0)) !== null && _styleOptionVariations_reduce !== void 0 ? _styleOptionVariations_reduce : 0;
        var perStyleMinOrderQuantity = (_product_purchase_information1 = product.purchase_information) === null || _product_purchase_information1 === void 0 ? void 0 : _product_purchase_information1.per_style_min_order_quantity;
        if (perStyleMinOrderQuantity && combinedSizeInventory < perStyleMinOrderQuantity) {
            return PerStyleVariationMapBuilder.disableAllOptions(styleOptionVariations);
        }
        styleOptionVariations = PerStyleVariationMapBuilder.redistributeInventory(styleOptionVariations, product);
        styleOptionVariations = PerStyleVariationMapBuilder.appendWSPSuffix(styleOptionVariations, product);
        styleOptionVariations = PerStyleVariationMapBuilder.appendShipWindowAndOrderByDate(styleOptionVariations, product);
    }
    return styleOptionVariations;
};
PerStyleVariationMapBuilder.getDefaultOptionVariation = function(styleGroup, product) {
    var _product_purchase_information;
    var numOptionsInStyleGroup = styleGroup.option_tokens.length;
    var _product_purchase_information_per_style_min_order_quantity;
    var perStyleMinOrderQuantity = (_product_purchase_information_per_style_min_order_quantity = (_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : _product_purchase_information.per_style_min_order_quantity) !== null && _product_purchase_information_per_style_min_order_quantity !== void 0 ? _product_purchase_information_per_style_min_order_quantity : 0;
    var defaultSelectedQuantity = Math.ceil(perStyleMinOrderQuantity / numOptionsInStyleGroup);
    return styleGroup.option_tokens.map(function(token) {
        var _productOption_variations_find, _product_purchase_information;
        var productOption = PerStyleVariationMapBuilder.getProductOption(token, product);
        var size = (_productOption_variations_find = productOption.variations.find(function(variation) {
            return variation.type === ProductVariationType.SIZE;
        })) === null || _productOption_variations_find === void 0 ? void 0 : _productOption_variations_find.value;
        var inventory = productOption.available_units;
        if (productOption.state === IProduct.State.SALES_PAUSED) {
            inventory = 0;
        } else if (((_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : _product_purchase_information.allow_sales_when_out_of_stock) || productOption.available_units === undefined) {
            inventory = Infinity;
        }
        return PerStyleVariationMapBuilder.IPerStyleOptionVariation.build({
            size: size,
            productOptionToken: token,
            selectedQuantity: defaultSelectedQuantity,
            inventory: inventory,
            orderabilityType: productOption.orderability_type
        });
    });
};
PerStyleVariationMapBuilder.disableAllOptions = function(styleOptionVariations) {
    // if the combined inventory is less than required MOQ, we should
    // disable the pickers by setting every option inventory to 0.
    styleOptionVariations === null || styleOptionVariations === void 0 ? void 0 : styleOptionVariations.forEach(function(variation) {
        variation.inventory = 0;
        variation.selectedQuantity = 0;
    });
    return styleOptionVariations;
};
PerStyleVariationMapBuilder.redistributeInventory = function(styleOptionVariations, product) {
    var _product_purchase_information;
    var areAllOptionQuantitiesValid = styleOptionVariations.every(function(variation) {
        return variation.selectedQuantity <= variation.inventory;
    });
    if (areAllOptionQuantitiesValid) {
        return styleOptionVariations;
    }
    styleOptionVariations.forEach(function(variation) {
        variation.selectedQuantity = 0;
    });
    var _product_purchase_information_per_style_min_order_quantity;
    var inventoryToDistribute = (_product_purchase_information_per_style_min_order_quantity = (_product_purchase_information = product.purchase_information) === null || _product_purchase_information === void 0 ? void 0 : _product_purchase_information.per_style_min_order_quantity) !== null && _product_purchase_information_per_style_min_order_quantity !== void 0 ? _product_purchase_information_per_style_min_order_quantity : 0;
    var areAllOptionQuantitiesFilled = styleOptionVariations.every(function(variation) {
        return variation.selectedQuantity === variation.inventory;
    });
    // either there is room the distribute or we are completely filled on every option
    // break and return either way.
    while(inventoryToDistribute > 0 && !areAllOptionQuantitiesFilled){
        for(var i = 0; i < styleOptionVariations.length; i++){
            var variation = styleOptionVariations[i];
            if (!variation) {
                continue;
            }
            if (variation.selectedQuantity === variation.inventory) {
                continue;
            }
            variation.selectedQuantity++;
            inventoryToDistribute--;
            if (inventoryToDistribute === 0) {
                break;
            }
        }
        areAllOptionQuantitiesFilled = styleOptionVariations.every(function(variation) {
            return variation.selectedQuantity === variation.inventory;
        });
    }
    return styleOptionVariations;
};
PerStyleVariationMapBuilder.setDatesForPreorders = function(styleOptionVariations, product, showDatesInQuantityPicker) {
    styleOptionVariations.filter(function(variation) {
        return variation.orderabilityType === IProductOption.OrderabilityType.PREORDER;
    }).forEach(function(variation) {
        var productOption = PerStyleVariationMapBuilder.getProductOption(variation.productOptionToken, product);
        var expectedShipDateRange = FaireDateRange.create(productOption.expected_ship_date, productOption.expected_ship_window_days);
        var orderByDate = FaireDate.fromNormalizedOrLocalEndOfDayTimestamp(productOption.stop_selling_at);
        if (expectedShipDateRange || orderByDate) {
            variation.showDatesInQuanitityPicker = showDatesInQuantityPicker;
        }
        if (expectedShipDateRange) {
            variation.expectedShipDate = expectedShipDateRange;
        }
        if (orderByDate) {
            variation.orderByDate = orderByDate;
        }
    });
};
PerStyleVariationMapBuilder.appendShipWindowAndOrderByDate = function(styleOptionVariations, product) {
    var _styleOptionVariations_;
    var _styleOptionVariations__productOptionToken;
    var baseOption = PerStyleVariationMapBuilder.getProductOption((_styleOptionVariations__productOptionToken = (_styleOptionVariations_ = styleOptionVariations[0]) === null || _styleOptionVariations_ === void 0 ? void 0 : _styleOptionVariations_.productOptionToken) !== null && _styleOptionVariations__productOptionToken !== void 0 ? _styleOptionVariations__productOptionToken : "", product);
    var baseOrderability = baseOption.orderability_type;
    var baseExpectedShipDate = baseOption.expected_ship_date;
    var baseExpectedShipWindowDays = baseOption.expected_ship_window_days;
    var baseOrderByDate = baseOption.stop_selling_at;
    var allIdenticalOrderability = styleOptionVariations.every(function(variation) {
        var productOption = PerStyleVariationMapBuilder.getProductOption(variation.productOptionToken, product);
        return isEqual(productOption.orderability_type, baseOrderability);
    });
    if (!allIdenticalOrderability) {
        // mixed orderability ATS & Preorder
        PerStyleVariationMapBuilder.setDatesForPreorders(styleOptionVariations, product, true);
    } else if (baseOrderability === IProductOption.OrderabilityType.PREORDER) {
        // all preorder
        var allIdenticalShipDateRangeAndOrderByDate = styleOptionVariations.every(function(variation) {
            var productOption = PerStyleVariationMapBuilder.getProductOption(variation.productOptionToken, product);
            return isEqual(productOption.expected_ship_date, baseExpectedShipDate) && isEqual(productOption.expected_ship_window_days, baseExpectedShipWindowDays) && isEqual(productOption.stop_selling_at, baseOrderByDate);
        });
        PerStyleVariationMapBuilder.setDatesForPreorders(styleOptionVariations, product, !allIdenticalShipDateRangeAndOrderByDate);
    }
    return styleOptionVariations;
};
PerStyleVariationMapBuilder.appendWSPSuffix = function(styleOptionVariations, product) {
    var _styleOptionVariations_;
    var _styleOptionVariations__productOptionToken;
    var baseOption = PerStyleVariationMapBuilder.getProductOption((_styleOptionVariations__productOptionToken = (_styleOptionVariations_ = styleOptionVariations[0]) === null || _styleOptionVariations_ === void 0 ? void 0 : _styleOptionVariations_.productOptionToken) !== null && _styleOptionVariations__productOptionToken !== void 0 ? _styleOptionVariations__productOptionToken : "", product);
    var baseWsp = baseOption.wholesale_price;
    var areAllWSPIdentical = styleOptionVariations.every(function(variation) {
        var productOption = PerStyleVariationMapBuilder.getProductOption(variation.productOptionToken, product);
        return isEqual(productOption.wholesale_price, baseWsp);
    });
    if (!areAllWSPIdentical) {
        // if there exists unique wholesale price (wsp), we want to show all the prices
        // in each picker individually.
        styleOptionVariations.forEach(function(variation) {
            var productOption = PerStyleVariationMapBuilder.getProductOption(variation.productOptionToken, product);
            variation.wholesalePrice = productOption.wholesale_price;
            variation.promoPrice = productOption.wholesale_promo_price;
        });
    }
    return styleOptionVariations;
};
PerStyleVariationMapBuilder.getProductOption = function(token, product) {
    return getProductOptions(product).find(function(option) {
        return option.token === token;
    });
};
(function(PerStyleVariationMapBuilder) {
    var IPerStyleOptionVariation;
    (function(IPerStyleOptionVariation) {
        IPerStyleOptionVariation.build = function(partial) {
            return _object_spread({
                size: "",
                productOptionToken: "",
                inventory: 0,
                selectedQuantity: 0
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IPerStyleOptionVariation = PerStyleVariationMapBuilder.IPerStyleOptionVariation || (PerStyleVariationMapBuilder.IPerStyleOptionVariation = {}));
})(PerStyleVariationMapBuilder || (PerStyleVariationMapBuilder = {}));
